import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { type AllActivitiesResponse } from '@repo/advanced-filters';
import {
  Button, Col, Flex, Row, Select, Typography,
} from 'antd';
import React from 'react';

import ComparatorRenderer from '../ComparatorRenderer';
import styles from './LeadActivityCreateMenu.module.scss';

interface ActivitySelectionProps {
  selectedActivities: { activityId: number }[];
  activitiesData?: AllActivitiesResponse;
  updateExistingField: (field: { activityId: number }, index: number) => void;
  deleteField: (index: number) => void;
  addNewDefaultField: () => void;
}

export default function ActivitySelection({
  selectedActivities,
  activitiesData,
  updateExistingField,
  deleteField,
  addNewDefaultField,
}: ActivitySelectionProps) {
  return (
    <>
      <Flex gap={8} vertical>
        {selectedActivities.map((activity, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={index}>
            <Flex gap={8}>
              <Row className={styles.changedAttributes}>
                <Col span={6}>
                  {index === 0 && <Typography.Text strong>Triggered Activity is </Typography.Text>}
                </Col>
                <Col span={12}>
                  <Select
                    value={activitiesData?.activities.find(
                      (_activity) => _activity.value === activity.activityId.toString(),
                    )?.value}
                    options={activitiesData?.activities ?? []}
                    onChange={(value) => updateExistingField({ activityId: parseInt(value, 10) }, index)}
                    style={{ width: '12rem' }}
                    showSearch
                    optionFilterProp="label"
                    className={styles.activitySelect}
                  />
                </Col>
                <Col>
                  {index !== 0 && (
                    <Button
                      type="link"
                      onClick={() => deleteField(index)}
                      icon={<DeleteOutlined />}
                      danger
                    >
                      Remove
                    </Button>
                  )}
                </Col>
              </Row>
            </Flex>
            { index !== selectedActivities.length - 1 && (
              <Row>
                <Col span={15}>
                  <ComparatorRenderer
                    comparator="or"
                    className={styles.comparator}
                  />
                </Col>
              </Row>
            )}
          </React.Fragment>
        ))}
      </Flex>
      <Button onClick={addNewDefaultField} icon={<PlusOutlined />}>Add New Field</Button>
    </>
  );
}
